<template>
    <ul class="menu" :class="ul_class">
        <li v-if="!footer.ocultar_afiliados">
            <router-link
                :to="{ name: 'front.afiliados.index' }"
                :class="btn_class"
                @click="closeMenu"
            >
                {{ $t('header.afiliados') }}
            </router-link>
        </li>
        <li v-if="!footer.ocultar_eventos">
            <router-link
                v-if="footer.partidos"
                :to="{ name: 'front.eventos.index' }"
                :class="btn_class"
                @click="closeMenu"
            >
                <template v-if="footer.tipo == config.DEPORTES">
                    {{ $t('header.partidos') }}
                </template>
                <template v-else>
                    {{ $t('header.eventos') }}
                </template>
            </router-link>

            <del v-else>
                <template v-if="footer.tipo == config.DEPORTES">
                    {{ $t('header.partidos') }}
                </template>
                <template v-else>
                    {{ $t('header.eventos') }}
                </template>
            </del>
        </li>
        <li v-if="footer.tipo == config.DEPORTES && !footer.ocultar_experiencias">
            <router-link
                v-if="footer.activar_experiencias"
                :to="{ name: 'front.experiencias.index' }"
                @click="closeMenu"
                :class="btn_class"
            >
                {{teatro.hash != 'UHmERrsRV19JCGQMg7Is' ? $t('header.experiencias') : 'FUTSAL FEST' }}
            </router-link>

            <del v-else>{{ teatro.hash != 'UHmERrsRV19JCGQMg7Is' ? $t('header.experiencias') : 'FUTSAL FEST'  }}</del>
        </li>
        <li v-if="!footer.ocultar_productos">
            <router-link
                v-if="footer.activar_productos"
                :to="{ name: 'front.productos.index' }"
                @click="closeMenu"
                :class="btn_class"
            >
                {{ $t('productos.productos') }}
            </router-link>
            <del v-else>{{ $t('productos.productos') }}</del>
        </li>
        <li v-if="!footer.ocultar_acreditaciones">
            <router-link
                v-if="footer.activar_acreditaciones"
                :to="{ name: 'front.acreditacion' }"
                @click="closeMenu"
                :class="btn_class"
            >
                {{ $t('header.acreditacion') }}
            </router-link>
            <del v-else>{{ $t('header.acreditacion') }}</del>
        </li>
        <li v-if="!footer.ocultar_parcelas && abonado.activar_parcelas">
            <router-link
                v-if="footer.activar_parcelas"
                :to="{ name: 'front.parcelas' }"
                @click="closeMenu"
                :class="btn_class"
            >
                {{ $t('home.parcelas') }}
            </router-link>
            <del v-else>{{ $t('home.parcelas') }}</del>
        </li>
        <li v-if="!footer.ocultar_pack">
            <router-link
                v-if="footer.activar_pack"
                :to="{ name: 'front.packs.index' }"
                @click="closeMenu"
                :class="btn_class"
            >
                {{ $t('header.packs') }}
            </router-link>
            <del v-if="!footer.activar_pack">{{ $t('header.packs') }}</del>
        </li>
        <li v-if="footer.tipo == config.DEPORTES && !footer.ocultar_futbol_base">
            <router-link
                v-if="footer.futbol_base"
                :to="{ name: 'front.bases.index' }"
                @click="closeMenu"
                :class="btn_class"
            >
                {{ $t('header.cantera') }}
            </router-link>

            <del v-else> {{ $t('header.cantera') }} </del>
        </li>
        <li v-if="!footer.ocultar_renovar_abono">
            <router-link 
                v-if="footer.renovar_abono"
                :to="{ name: 'front.abonos.renovar.index' }"
                @click="closeMenu"
                :class="btn_class"
            >
                {{ $t('header.renovar' , {abono: teatro.texto_abono}) }}
            </router-link>

            <del v-else>{{ $t('header.renovar' , {abono: teatro.texto_abono}) }}</del>
        </li>
        <li v-if="!footer.ocultar_abonos">
            <router-link
                v-if="footer.nuevo_abono"
                :to="{ name: 'front.abonos.nuevo.index' }"
                @click="closeMenu"
                :class="btn_class"
            >
                {{ abonado.btn_nuevo_abono ? abonado.btn_nuevo_abono : (teatro.hash !== '8IuCwC47T9n0qgn2ky0G' ? $t('home.nuevo_abono', {abono: teatro.texto_abono}) : $t('home.nuevo_abono_talavera', {abono: teatro.texto_abono.toUpperCase()})) }}
            </router-link>

            <del v-else> {{ teatro.hash !== '8IuCwC47T9n0qgn2ky0G' ? $t('home.nuevo_abono', {abono: teatro.texto_abono}) : $t('home.nuevo_abono_talavera', {abono: teatro.texto_abono.toUpperCase()}) }}</del>
        </li>
        <li hidden="true" v-if="false">
            <router-link
                v-if="footer.nuevo_abono"
                :to="{ name: 'front.bases.crear' }"
                @click="closeMenu"
                :class="btn_class"
            >
                Inscribir base
            </router-link>

            <del v-else>Inscribir base</del>
        </li>
        <li v-if="false">
            <router-link
                v-if="footer.venta_simpatizantes"
                :to="{ name: 'front.simpatizantes.index' }"
                :class="btn_class"
                @click="closeMenu"
            >
                {{ configuracion.simpatizantes }}
            </router-link>

            <del v-else>{{ configuracion.simpatizantes }}</del>
        </li>
        <li v-if="footer.lfp === 1 && teatro.sga === 0">
            <router-link
                :to="{ name: 'mi-abono' }"
                @click="closeMenu"
                :class="btn_class"
            >
                {{ $t('header.mi_abono')}}
            </router-link>
        </li>
        <li v-if="footer.tipo == config.DEPORTES">
            <router-link
                :to="!is_logged ? { name: 'login' } : { name: 'perfil', query: { tab: 'abonos' } }"
                @click="closeMenu"
                :class="btn_class"
            >
                {{ $t('header.liberar_asiento') }}
            </router-link>
        </li>
        <li v-if="footer.tipo == config.DEPORTES && !footer.ocultar_renovacion_futbol_base">
            <router-link
                v-if="footer.renovacion_futbol_base"
                :to="{ name: 'front.bases.renovar' }"
                @click="closeMenu"
                :class="btn_class"
            >
                {{ $t('header.renovar_cantera') }}
            </router-link>

            <del v-else> {{ $t('header.renovar_cantera') }} </del>
        </li>
        <li v-if="teatro.sga == 1">
            <router-link
                :to="{ name: 'front.abonos.buscar-abonado' }"
                :class="btn_class"
            >
                {{ $t('header.buscar') }}
            </router-link>
        </li> 
        <li>
            <router-link
                :to="{ name: 'ayuda' }"
                :class="btn_class"
            >
                {{ $t('header.ayuda') }}
            </router-link>
        </li>                        
    </ul>
</template>

<script>

    import { config } from '@/config.js';

    export default {
        props: {
            btn_class: String,
            footer: Object,
            configuracion: Object,
            ul_class: String
        },
        methods: {
            logout() {
                this.$store.dispatch('logout', { router : this.$router });
            },
            closeMenu() {
                this.$emit('closeMenu');
            }
        },
        computed: {
            is_logged() {
                return this.$store.getters.isLogged;
            },
            user() {
                return this.$store.getters.getUser;
            },
            abonado(){
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro
            }
        }
    }
</script>

<style scoped>
    ul li {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        float: center;
    }
</style>